import tw from "twin.macro";

export const SectionHeading = tw.h2` -mt-8 text-4xl sm:text-5xl font-black tracking-wide text-center`
export const Subheading = tw.h5` -mt-16 font-bold text-primary-500`
